<template>
   <div class="container">
      <div class="row">
         <div class="col-12">
            <div class="navbar navbar--hamburger collapse" id="menuHamburger">
               <LayoutsMenusMain @link-clicked="handleLinkClick" />
            </div>
         </div>
      </div>
   </div>
</template>


<script setup>
import { ref } from 'vue';
import { useTranslationStore } from '@/stores/translations';
import { useShinyButton } from '@/composables/useShinyButton';


const translationStore = useTranslationStore()
const translate = translationStore.translate
const { shinyButton } = useShinyButton()


const handleLinkClick = () => {
   const menu = document.getElementById('menuHamburger');
   const toggler = document.querySelector('.navbar-toggler');

   if (menu) {
      menu.classList.remove('show');

      if (toggler) {
         toggler.classList.add('collapsed');
         toggler.setAttribute('aria-expanded', 'false');
      }
   }

   const mainDropdownToggles = document.querySelectorAll('.navbar-nav--lv1 .nav-link.dropdown-toggle.show');
   mainDropdownToggles.forEach(toggle => {
      toggle.classList.remove('show');
      toggle.setAttribute('aria-expanded', 'false');
      
      const dropdownWrapper = toggle.nextElementSibling;
      if (dropdownWrapper && dropdownWrapper.classList.contains('dropdown-menu--wrapper')) {
         dropdownWrapper.classList.remove('show');

         const level3Menus = dropdownWrapper.querySelectorAll('.dropdown-menu.dropdown-menu--lv3.show');
         level3Menus.forEach(menu => {
            menu.classList.remove('show');
         });
      }
   });
};
</script>

<style lang="scss" >
@import "@/assets/scss/app";

@each $lang in $languages {
   html[lang="#{$lang}"] {
      .navbar {  
         &.navbar--hamburger {
            
         }
      }
   }
}

.navbar {  
    &.navbar--hamburger {
        position: unset;
        padding: 1rem 0;
        opacity: 0;
        @include transition(0.3s);

        &.show{
            opacity: 1;
            @include transition(0.3s);
        }

        .navbar-collapse {
            @include media-breakpoint-up(lg) {
                height: 100%;
            }   
            &:not(.show) {
                display: block;    
            }
        }

        .navbar-nav {  
            &.navbar-nav--lv1 {
                @include media-breakpoint-down(xl) {
                    width: 100%;
                    flex-direction: column;
                }
                

                .nav-item {
                    position: static;
                     .nav-link {
                        color: $black;
                        padding: 6px 0;
                        white-space: wrap;

                        &.dropdown-toggle {
                           &::before{
                              content: none;
                           }
                        }
                     }
                }
            }
        }
    }
}

</style>
